import { useQuery } from "@tanstack/react-query";
import { partnerApiService } from "@/services/partner-api.service";

export const useOverviewStats = () => {
	return useQuery({
		queryKey: ["partner", "overview", "stats"],
		queryFn: partnerApiService.getStats,
	});
};
